import dom, { Fragment } from "../../dist/jsx-render/dom"
import { TextComponent } from "./TextComponent";
import { ComponentBase } from "./ComponentBase";
import { Constants } from "../Common/constants";
import { LabeledTextComponent } from "./LabeledTextComponent";
import { app } from "../Frame/App";

type LanguageStringComponentProps = {
    model: any;
    name?: string;
    beforeChangeEvent?: (event: Event, changedValue?: string) => void;
    changeEvent?: (event: Event, oldValue?: string) => void;
    onBlurEvent?: (event: Event) => void;
    alwaysExpanded?: boolean;
    textarea?: boolean;
    additionalCssClasses?: string;

    /** Form group is created if null oder true. To not create a form group, set explicitly to false. */
    createFormGroup?: boolean;
    showLabel?: boolean;
    lines?: number;

    /** Max Length of the input fields. */
    maxLength?: number;

    changeLanguageEvent?: (event: Event) => void;
}

export class LanguageStringComponent extends ComponentBase {
    constructor(props: LanguageStringComponentProps) { super(props); }
    props: LanguageStringComponentProps;

    selectedLanguage: string;
    isExpanded: boolean;
    availableLanguagesWithoutCurrent: string[] = app.availableLanguages.filter(av => av != app.defaultLanguage);

    prependLanguage = (language: string, addListener: boolean = false): HTMLElement => {
        let prependElement: HTMLElement = <div className="input-group-prepend">
            <div className="input-group-text">
                <img src={app.resolveUrl("~/images/lang_" + language + ".gif")} />
            </div>
        </div>
        if (!this.props.alwaysExpanded && addListener === true) {
            prependElement.addEventListener('click', this.toggleExpanded);
        }
        return prependElement;
    }

    //<div className="language-string-control-column name-in-languages">
    element: HTMLElement;
    getElement() {
        return <div className={"language-string-control" + (this.props.additionalCssClasses ? " " + this.props.additionalCssClasses : "")}>
            <div className="single-language-control in-language">
                <TextComponent
                    model={this.props.model}
                    field={'value' + app.defaultLanguageUpperCase}
                    name={this.props.name}
                    attributes={{ "lang": 'value' + app.defaultLanguageUpperCase }}
                    beforeChangeEvent={this.props.beforeChangeEvent}
                    changeEvent={this.props.changeEvent}
                    onBlurEvent={this.props.onBlurEvent}
                    textarea={this.props.textarea}
                    createFormGroup={this.props.createFormGroup}
                    showLabel={this.props.showLabel}
                    lines={this.props.lines}
                    maxLength={this.props.maxLength}>
                    {this.prependLanguage(app.defaultLanguageUpperCase, true)}
                </TextComponent>
            </div>

            <div className={"all-languages name-field"
                + (!this.props.alwaysExpanded ? " expandable " + Constants.cssClass_hidden : "")}>

                {this.availableLanguagesWithoutCurrent.map(av =>
                    <div className="single-language-control">
                        <TextComponent
                            model={this.props.model}
                            field={'value' + app.capitalizeLanguageString(av)}
                            attributes={{ "lang": 'value' + app.capitalizeLanguageString(av) }}
                            name={this.props.name}
                            createFormGroup={this.props.createFormGroup}
                            textarea={this.props.textarea}
                            beforeChangeEvent={this.props.beforeChangeEvent}
                            changeEvent={this.props.changeLanguageEvent}
                            onBlurEvent={this.props.onBlurEvent}
                            showLabel={false}
                            lines={this.props.lines}
                            maxLength={this.props.maxLength}>
                            {this.prependLanguage(av)}
                        </TextComponent>
                    </div>
                )}
            </div>
        </div>;
    }

    render() {
        //if (app.availableLanguages.length < 4) {
        //    this.props.alwaysExpanded = true;
        //}

        if (this.props.alwaysExpanded === true) {
            this.isExpanded = true;
        } else {
            this.isExpanded = false;
        }

        this.element = this.getElement();

        return this.element;
    }

    getExpandLanguagesButton() {
        let buttonElement = <div className="language-string-icon icon1 fa-globe fas"></div>;
        buttonElement.addEventListener('click', this.toggleExpanded);

        return buttonElement;
    }

    private toggleExpanded = (event: MouseEvent) => {
        let expandableElements = this.element.querySelectorAll(".expandable");

        if (!this.isExpanded) {
            expandableElements.forEach(e => e.classList.remove(Constants.cssClass_hidden));
        } else {
            expandableElements.forEach(e => e.classList.add(Constants.cssClass_hidden));
        }

        this.isExpanded = !this.isExpanded;
    }

    dispose() { }

    validate() { }
}


//<LabeledTextComponent
//    model={this.props.model}
//    field={'value' + app.languageUpperCase}
//    name={this.props.name}
//    changeEvent={this.props.changeEvent}
//    textarea={this.props.textarea}>
//    {this.prependLanguage(app.languageUpperCase, true)}
//</LabeledTextComponent>